import Activity from "./activity"
import ActivityPackages from "./activityPackages"
import Catalogue from "./catalogue"
import Regions from "./regions"
import Properties from "./properties"
//import Search from "./search"
import ShippingTypes from "./shippingTypes"
import Testimonials from "./testimonials"
import Storage from "./storage"
import Promocode from "./promocode"
import Newsletter from "./newsletter"
import Validation from "./validation"

import Config from "../config"
import Cart from "./cart"
import Api from "./api"

const load = () => {
  return new Promise((resolve, reject) => {
    Api.get(`data/${Config.country}`)
      .then(response => {
        if(response.error) {
          // TODO 
          reject(response.error)
        }
        else {
          // cache
          Catalogue.init(response.catalogue)
          Regions.set(response.regions)
          Properties.set(response.properties)
          ShippingTypes.set(response.shippingTypes)
          Testimonials.set(response.testimonials)
          ActivityPackages.set(response.activityPackages)

          // init the cart (restore from local storage or empty adventure)
          Cart.init()
          // resolve
          resolve({
            catalogue:Catalogue.getData(),
            regions:Regions.get(),
            properties:Properties.get(),
            shippingTypes:ShippingTypes.get(),
            testimonials:Testimonials.get(),
            activityPackages:ActivityPackages.get(),
          })
        }
      })
      .catch(error => {
        reject(error)
      })
  })
  
}

export default {
  load, 
  Activity, 
  Cart, 
  Catalogue, 
  Newsletter,
  Promocode,
  Properties, 
  Regions, 
  //Search,
  ShippingTypes,
  Storage,
  Testimonials,
  ActivityPackages,
  Validation,
}